import api from './api';

// Service du module « Supervision Marketing & Digital ».
const mhApi = {
  // ── Gandi (noms de domaine) ───────────────────────────────────────
  listGandiDomains:   () => api.get('/mkt-gandi/domains'),
  updateGandiDomain:  (fqdn, data) => api.put(`/mkt-gandi/domains/${encodeURIComponent(fqdn)}`, data),
  refreshGandiCosts:  () => api.post('/mkt-gandi/domains/refresh-costs'),

  // ── Outils & accès ────────────────────────────────────────────────
  listTools:  () => api.get('/mkt-tools'),
  createTool: (data) => api.post('/mkt-tools', data),
  updateTool: (id, data) => api.put(`/mkt-tools/${id}`, data),
  deleteTool: (id) => api.delete(`/mkt-tools/${id}`),

  // ── Catalogue de services ─────────────────────────────────────────
  listServices:  () => api.get('/mkt-services'),
  createService: (data) => api.post('/mkt-services', data),
  updateService: (id, data) => api.put(`/mkt-services/${id}`, data),
  deleteService: (id) => api.delete(`/mkt-services/${id}`),

  // ── Clients ───────────────────────────────────────────────────────
  listClients:  () => api.get('/mkt-clients'),
  getClient:    (id) => api.get(`/mkt-clients/${id}`),
  createClient: (data) => api.post('/mkt-clients', data),
  updateClient: (id, data) => api.put(`/mkt-clients/${id}`, data),
  deleteClient: (id) => api.delete(`/mkt-clients/${id}`),

  // ── Sites (registre) ──────────────────────────────────────────────
  listSites:   () => api.get('/mkt-sites'),
  getSite:     (id) => api.get(`/mkt-sites/${id}`),
  createSite:  (data) => api.post('/mkt-sites', data),
  updateSite:  (id, data) => api.put(`/mkt-sites/${id}`, data),
  deleteSite:  (id) => api.delete(`/mkt-sites/${id}`),
  getCosts:    (id) => api.get(`/mkt-sites/${id}/costs`),
  addCost:     (id, data) => api.post(`/mkt-sites/${id}/costs`, data),

  // ── Journal d'actions par site ────────────────────────────────────
  listSiteActions: (siteId) => api.get(`/mkt-sites/${siteId}/actions`),
  listAllActions:  (params) => api.get('/mkt-sites/actions/all', { params }),
  addSiteAction:   (siteId, data) => api.post(`/mkt-sites/${siteId}/actions`, data),
  updateAction:    (actionId, data) => api.put(`/mkt-sites/actions/${actionId}`, data),
  deleteAction:    (actionId) => api.delete(`/mkt-sites/actions/${actionId}`),
  chartActions:    (params) => api.get('/mkt-sites/actions/for-chart', { params }),

  // ── Projets & tâches ──────────────────────────────────────────────
  listMembers:  () => api.get('/mkt-projects/members'),
  listProjects: (params) => api.get('/mkt-projects', { params }),
  getProject:   (id) => api.get(`/mkt-projects/${id}`),
  createProject:(data) => api.post('/mkt-projects', data),
  updateProject:(id, data) => api.put(`/mkt-projects/${id}`, data),
  moveProject:  (id, data) => api.patch(`/mkt-projects/${id}/move`, data),
  deleteProject:(id) => api.delete(`/mkt-projects/${id}`),
  addTask:      (projectId, data) => api.post(`/mkt-projects/${projectId}/tasks`, data),
  updateTask:   (taskId, data) => api.put(`/mkt-projects/tasks/${taskId}`, data),
  toggleTask:   (taskId) => api.patch(`/mkt-projects/tasks/${taskId}/toggle`),
  deleteTask:   (taskId) => api.delete(`/mkt-projects/tasks/${taskId}`),

  // ── Pointage ──────────────────────────────────────────────────────
  getTimer:     () => api.get('/mkt-pointage/timer'),
  startTimer:   (data) => api.post('/mkt-pointage/start', data),
  stopTimer:    (data) => api.post('/mkt-pointage/stop', data),
  manualEntry:  (data) => api.post('/mkt-pointage/manual', data),
  listEntries:  (params) => api.get('/mkt-pointage/entries', { params }),
  updateEntry:  (id, data) => api.put(`/mkt-pointage/entries/${id}`, data),
  deleteEntry:  (id) => api.delete(`/mkt-pointage/entries/${id}`),
  timesheet:    (params) => api.get('/mkt-pointage/timesheet', { params }),

  // ── Audits ────────────────────────────────────────────────────────
  listAudits:   () => api.get('/mkt-audits'),
  siteRuns:     (siteId) => api.get(`/mkt-audits/site/${siteId}`),
  getRun:       (runId) => api.get(`/mkt-audits/run/${runId}`),
  trend:        (siteId) => api.get(`/mkt-audits/trend/${siteId}`),
  uptime:       (siteId) => api.get(`/mkt-audits/uptime/${siteId}`),
  runNow:       (siteId) => api.post('/mkt-audits/run-now', { site_id: siteId }),
  convertFinding: (id, data) => api.post(`/mkt-audits/findings/${id}/convert-to-task`, data || {}),
  patchFinding: (id, data) => api.patch(`/mkt-audits/findings/${id}`, data),
  deleteRun:    (runId) => api.delete(`/mkt-audits/run/${runId}`),

  // ── Make (monitoring scénarios) ───────────────────────────────────
  makeConfig:      () => api.get('/make/config'),
  makeOverview:    () => api.get('/make/overview'),
  makeScenarios:   (params) => api.get('/make/scenarios', { params }),
  makeExecutions:  (id) => api.get(`/make/scenarios/${id}/executions`),
  makeUsageTrend:  () => api.get('/make/usage-trend'),
  makeSync:        () => api.post('/make/sync'),
};

export default mhApi;
